export const ItemTypes = {
    SET_DRESSING: "setDressing"
};
